module.exports = "/assets/data/e2e69b920755f061ee9ec86ea6a58113-NW2.data.json";